
import { useNotificationsStore, useRemoveNotification } from "@store";

import {
  NotificationManager as UINotificationManager,
  type NotificationProps,
} from "@bracket/ui";

import type { Notification } from "@bracket/ui";

const adaptNotification = (
  notification: Notification,
  onClose: (id: string) => void
): NotificationProps => ({
  id: notification.id,
  title: notification.title,
  message: notification.message,
  type: notification.type,
  primaryAction: notification.primaryAction,
  secondaryAction: notification.secondaryAction,
  onClose: () => onClose(notification.id),
});

export const NotificationManager = () => {
  const { notifications } = useNotificationsStore();
  const removeNotification = useRemoveNotification();

  const adaptedNotifications = notifications.map((n) =>
    adaptNotification(n, removeNotification)
  );

  return (
    <UINotificationManager
      notifications={adaptedNotifications}
      onClose={removeNotification}
    />
  );
};
